import { render } from "./UserSelect.vue?vue&type=template&id=40434d9c&ts=true"
import script from "./UserSelect.vue?vue&type=script&lang=ts"
export * from "./UserSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__